import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class RushFragmentSerializer extends FragmentSerializer {
    getRawFragment(play, serializationContext, rush) {
        const formattedFieldPosition = this.resolveFormattedFieldPosition(
            serializationContext,
            rush.getFieldPosition()
        );

        const uniform = this.resolveUniform(
            serializationContext,
            rush.getPlayers()[0]
        );

        const values = [uniform, formattedFieldPosition];

        return `RUSH:${values.join()}`;
    }

    applicable(fragment) {
        return [
            FootballState.Rush,
            FootballState.FieldGoalFakeRun,
            FootballState.KneelDown
        ].some((s) => s === fragment.associatedState);
    }

    getTypeCode(fragment) {
        return fragment.rushType?.code;
    }
}
